import store from "@/store"

export const getTreeItem = (data) => {

    data['time'] = formatDatetoNew(data.createTime)
    data['owner'] = data.clientId == store.getters.clientId
    data['hasShowMore'] = false
    data['toShowMore'] = false
    data['replayFlagF'] = false
    return data



}
export const formatDatetoNew = (date) => {

    var td = new Date().getTime();


    var od = new Date(date.replace(/-/g, "/")).getTime();;
    var dayDiff = td - od
    console.log(dayDiff, 'dayDiff')
    var day = Math.floor(dayDiff / (24 * 3600 * 1000))

    var leave2 = leave1 / (3600 * 1000)
    var leave3 = leave2 / (60 * 1000)

    if (day > 0) {
        if (day < 10) {
            return (Math.ceil(day) + '天前')
        }
        else {
            return date
        }

    }
    else {
        var leave1 = dayDiff % (24 * 3600 * 1000)

        var hours = Math.floor(leave1 / (3600 * 1000))
        if (hours > 0) {
            return (Math.ceil(hours) + '小时前')
        }
        else {
            var leave2 = leave1 % (3600 * 1000)

            var minutes = Math.floor(leave2 / (60 * 1000))
            if (minutes > 0)
                return (Math.ceil(minutes) + '分钟前')
            else {
                var leave3 = leave2 % (60 * 1000)

                var a = Math.ceil(leave3 / 1000)
                if (a < 0 || a == 0)
                    return ('刚刚')
                else
                    return (Math.ceil(leave3 / 1000) + '秒前')

            }

        }


    }


}